
import { t } from "i18next";
import store from "..";
import { MESSAGE_BAR_TYPES } from "../../utils/constants";
import { fiatWithdraw, getCountries, getFiatBankForm, getFiatBanks, getFiatWithdrawFees, } from "../api";
import { CLEAR_BANK_FORMDATA, CONNECT_BANK, GET_CONNECTED_BANKS, GET_COUNTRY, GET_POCKYT_BANK_FORM_DATA, GET_POCKYT_FEES, REPLACE_BANK, SET_LAST_REFRENCE_ID, SET_SKIP, SHOW_MESSAGE } from "./actionTypes";

export const getCountriesData = () => async (dispatch) => {
  try {
    const response = await getCountries();
    await dispatch({
      type: GET_COUNTRY,
      payload: response.result,
    });
  } catch (err) {
    dispatch({
      type: SHOW_MESSAGE,
      payload: {
        type: MESSAGE_BAR_TYPES.ERROR,
        message: err?.response?.data?.message || err.message
      }
    });
  }
};

export const addSkipIndex = (skip, setActive) => dispatch => {
  try {
    let payload = [];
    const { transfer } = store.getState();
    if (skip) {
      payload = [...new Set([...transfer.skip, skip])]
    }
    dispatch({
      type: SET_SKIP,
      payload: payload
    })
    if (typeof setActive === 'function') setActive();
  } catch (err) {
    dispatch({
      type: SHOW_MESSAGE,
      payload: {
        type: MESSAGE_BAR_TYPES.ERROR,
        message: err?.response?.data?.message || err.message
      }
    });
  }
}

export const removeSkipIndex = (skip, setActive) => dispatch => {
  try {
    const { transfer } = store.getState();
    const filtered = transfer.skip.filter(v => v !== skip);
    dispatch({
      type: SET_SKIP,
      payload: filtered
    })
    if (typeof setActive === 'function') setActive();
  } catch (err) {
    dispatch({
      type: SHOW_MESSAGE,
      payload: {
        type: MESSAGE_BAR_TYPES.ERROR,
        message: err?.response?.data?.message || err.message
      }
    });
  }
}

export const setLastRefId = (payload) => dispatch => {
  dispatch({
    type: SET_LAST_REFRENCE_ID,
    payload
  })
}

export const getPockytConnectedBanks = () => async (dispatch) => {
  try {
    const { dashboard } = store.getState();
    if (!dashboard?.fiatService?.enableFiat) {
      return true;
    }
    const response = await getFiatBanks();
    await dispatch({
      type: GET_CONNECTED_BANKS,
      payload: response.result,
    });
  } catch (err) {
    dispatch({
      type: SHOW_MESSAGE,
      payload: {
        type: MESSAGE_BAR_TYPES.ERROR,
        message: err?.response?.data?.message || err.message
      }
    });
  }
}

export const connectBank = (payload) => async (dispatch) => {
  await dispatch({
    type: CONNECT_BANK,
    payload,
  });
}

export const getPockytBankFormData = (currency, country, onSuccess, onFailure) => async (dispatch) => {
  try {
    const response = await getFiatBankForm(currency, country);
    await dispatch({
      type: GET_POCKYT_BANK_FORM_DATA,
      payload: response.result,
    });
    if (typeof onSuccess === 'function') onSuccess();
  } catch (err) {
    if (typeof onFailure === 'function') onFailure(err);
    // dispatch({
    //   type: SHOW_MESSAGE,
    //   payload: {
    //     type: MESSAGE_BAR_TYPES.ERROR,
    //     message: err?.response?.data?.message || err.message
    //   }
    // });
  }
}

export const getPockytFees = (payload,currency, country, isConflict) => async (dispatch) => {
  try {
    const response = await getFiatWithdrawFees(payload, currency, country);
    if (response?.result?.error) {
      dispatch({
        type: SHOW_MESSAGE,
        payload: {
          type: MESSAGE_BAR_TYPES.ERROR,
          message: t('transferFailed')
        }
      });
    }
    await dispatch({
      type: GET_POCKYT_FEES,
      payload: response.result,
    });
  } catch (err) {
    if (err?.response?.data?.data?.isConflict && typeof isConflict === 'function') isConflict(true);
    else
      dispatch({
        type: SHOW_MESSAGE,
        payload: {
          type: MESSAGE_BAR_TYPES.ERROR,
          message: err?.response?.data?.message || err.message
        }
      });
  }
}
export const pockytFiatWithdraw = (payload) => async (dispatch) => {
  try {
    const response = await fiatWithdraw(payload);
    return response.result;
  } catch (err) {
    dispatch({
      type: SHOW_MESSAGE,
      payload: {
        type: MESSAGE_BAR_TYPES.ERROR,
        message: err?.response?.data?.message || err.message
      }
    });
  }
}

export const replaceBankDetails = (payload) => async (dispatch) => {
  await dispatch({
    type: REPLACE_BANK,
    payload,
  });
}
export const clearPockytFees = (payload) => async (dispatch) => {
  await dispatch({
    type: GET_POCKYT_FEES,
    payload: {},
  });
}

export const clearBankForm = () => async (dispatch) => {
  await dispatch({
    type: CLEAR_BANK_FORMDATA
  });
}